export type ProblemStatus = 'open' | 'under-review' | 'funded' | 'closed';
export type SolutionStatus = 'proposed' | 'negotiating' | 'funded' | 'launched';

export interface FundingOffer {
  id: string;
  investor: string;
  investorReputation: number;
  amount: number;
  equity: number;
  terms: string;
  status: 'pending' | 'accepted' | 'rejected';
  submittedAt: string;
}

export interface Comment {
  id: string;
  author: string;
  authorRole: 'poster' | 'entrepreneur' | 'investor';
  authorReputation: number;
  rating: number;
  text: string;
  postedAt: string;
  likes: number;
}

export interface Solution {
  id: string;
  title: string;
  entrepreneur: string;
  entrepreneurReputation: number;
  status: SolutionStatus;
  fundingAsk: number;
  fundingOffered: number;
  rating: number;
  ratingCount: number;
  excerpt: string;
  tags: string[];
  submittedAt: string;
  fundingOffers: FundingOffer[];
  image?: string;
  imageAlt?: string;
  userId?: string; // DB user_id for ownership checks
  entrepreneurVerified?: boolean; // Entrepreneur self-verification flag
  ownerIsVerified?: boolean; // Admin-verified identity flag
  // Entrepreneur form fields
  problem?: string;
  solution?: string;
  productService?: string;
  marketSize?: string;
  competition?: string;
  fundingNeeded?: string;
  pricePerShare?: string;
  invest?: string;
  revenue?: {m6: string;m12: string;m18: string;m24: string;};
  expenses?: {m6: string;m12: string;m18: string;m24: string;};
  profit?: {m6: string;m12: string;m18: string;m24: string;};
}

export interface Problem {
  id: string;
  title: string;
  category: string;
  categoryColor: string;
  status: ProblemStatus;
  poster: string;
  posterReputation: number;
  posterRole: 'poster';
  postedAt: string;
  postedTimestamp: number;
  excerpt: string;
  fullDescription: string;
  fundingTarget: number;
  fundingRaised: number;
  solutions: Solution[];
  comments: Comment[];
  bookmarks: number;
  followers: number;
  image?: string;
  imageAlt?: string;
  // Problem form fields
  town?: string;
  country?: string;
  continent?: string;
  dateOccurred?: string;
  dateFuture?: string;
  affectedGroup?: string;
  effects?: string;
  workaround?: string;
  proposedSolution?: string;
  userId?: string; // DB user_id for ownership checks
}

export const MOCK_PROBLEMS: Problem[] = [];